import { PageDefaultSegment } from "@sis/react-library";
import { PageContainer } from "../../../shared/PageContainer"
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';

export const OtherSamplesPageLayoutPage = () => {
  return (
    <PageContainer heading='Other Samples - Page Layout' icon={<MiscellaneousServicesIcon />} >
      <PageDefaultSegment>
        The library also contains page layouts. <br />
        This project is using the PageLayoutDefault component. <br />
        If you need to create a different layout used in multiple projects, consider adding it to the library using a different name. <br />
        <br />
        <h3>PageLayoutDefault layout</h3>
        Take note of the following components in this project to see how the layout is implimented: <br />
        <br />
        <b>src/App.tsx</b><br />
        <ul>
          <li>The router route path "/" is set to component <i>LayoutContainer</i> (which is a component in this project which will reference the library).</li>
          <li>All other pages will be listed as children under this route path.</li>
        </ul>
        <b>LayoutContainer</b><br />
        Found in file <i>'src/components/layout'</i><br />
        <ul>
          <li>This component users the PageLayoutDefaultContainer from the library.</li>
          <li>The PageLayoutDefaultContainer creates the whole layout on your page, it accepts props for your menu items and your app bar items.</li>
          <li>The file in this sample project has comments on how to configure the layout, for example you can make the menu non collapsable.</li>
          <li>Note that the library cannot initiate correct values of hooks, components from react-router-dom.<br />
            They have to be passed into the PageLayoutDefaultContainer component. See the code example in the LayoutContainer component to see how to do this.</li>
        </ul>
        <br />
        <b>PageDefaultContainer</b><br />
        <ul>
          <li>Every top level page component should be wrapped in a PageDefaultContainer component.</li>
          <li>For an example refer to file <i>'src/components/formSamples/formSamplesPages/FormSamplesAboutPage.tsx'</i></li>
          <li>This component makes sure your page components margins are correct and creates a header at the top of the page.<br />
            (or you can add the noHeader prop if you don't want a header).<br />
            The header is also fixed and does not get scrolled away if the page is lengthly and has a scroll.</li>
          <li>In this sample application every page component actually is wrapped in a PageContainer component found in this application.<br />
            This PageContainer application then makes use of the PageDefaultContainer component from the library, and sets the title for the page.</li>
          <li>The PageDefaultContainer can also take a rightElement prop (like the info buttons in this sample application).<br />
            For Mobile you can choose to wrap this to the next line or keep it on the right side. (some headings are too long and you might want to wrap it).<br />
            This sample application shows some info buttons on the right for mobile, and some it wraps to the next line.</li>
        </ul>
        <b>PageDefaultSegment</b><br />
        <ul>
          <li>To segment different areas of your page you can wrap them in a PageDefaultSegment component.</li>
          <li>This component wraps the section in a white area. It accepts a width and will center align.</li>
          <li>If no width is specified then it fills the entire width.</li>
          <li>For an example refer to file <i>'src/components/formSamples/formSamplesPages/FormSamplesAboutPage.tsx'</i></li>
        </ul>        
      </PageDefaultSegment>
    </PageContainer>
  )
}
